import React from 'react';
import PropTypes from 'prop-types';

import Button from './Button';

const UserAccountsEditRow = ({
  type,
  email,
  emailOnChange,
  firstName,
  firstNameOnChange,
  lastName,
  lastNameOnChange,
  handleCancelButton,
  handleSaveButton,
  emailAddressValid,
  isAdmin,
  handleAdminCheckbox,
  emailAddressInUse,
  inputValid,
}) => (
  <tr className="UserAccountsEditRow">
  {type === "add" ? (
    <React.Fragment>
      <td>
        <input
          className="UserAccountsEditRow_input"
          type="text"
          value={firstName}
          onChange={firstNameOnChange}
          placeholder="First name..."
        />
      </td>
      <td>
        <input
          className="UserAccountsEditRow_input"
          type="text"
          value={lastName}
          onChange={lastNameOnChange}
          placeholder="Last name..."
        />
      </td>
      <td>
        <input
          className="UserAccountsEditRow_input"
          type="email"
          value={email}
          onChange={emailOnChange}
          placeholder="Email address..."
        />
        {!emailAddressValid && (
          <p className="UserAccountsEditRow_error-message">
            Email address not valid
          </p>
        )}
        {emailAddressInUse && (
          <p className="UserAccountsEditRow_error-message">
            Email already in use
          </p>
        )}
      </td>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <td>{firstName}</td>
      <td>{lastName}</td>
      <td>{email}</td>
    </React.Fragment>
  )}
    <td>
      <label
        className="UserAccountsEditRow_checkbox-label"
        htmlFor={`checkbox-admin-${email}`}
      >
        Admin
        <input
          className="UserAccountsEditRow_checkbox"
          type="checkbox"
          id={`checkbox-admin-${email}`}
          checked={isAdmin}
          onChange={handleAdminCheckbox}
        />
      </label>
      <Button onClick={handleCancelButton} label="Cancel" color="secondary" />{' '}
      <Button label="Save" onClick={handleSaveButton} disabled={!inputValid()} />
    </td>
  </tr>
);

UserAccountsEditRow.propTypes = {
  email: PropTypes.string.isRequired,
  emailOnChange: PropTypes.func.isRequired,
  firstName: PropTypes.string.isRequired,
  firstNameOnChange: PropTypes.func.isRequired,
  lastName: PropTypes.string.isRequired,
  lastNameOnChange: PropTypes.func.isRequired,
  handleCancelButton: PropTypes.func.isRequired,
  handleSaveButton: PropTypes.func.isRequired,
  emailAddressValid: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  emailAddressInUse: PropTypes.bool.isRequired,
  handleAdminCheckbox: PropTypes.func.isRequired,
};

export default UserAccountsEditRow;
